<template>
  <base-container :fluid="true" class="pf-table-view">
    <base-container>
      <the-header>
        <template v-slot:leftAligned>
          <h1 class="lvl1-heading">
            Liste
            <span>d'utilisateurs</span>
          </h1>
        </template>
      </the-header>
    </base-container>
    <div class="pf-table-view__main">
      <base-container :fluid="true" class="pf-table-view__filters">
        <el-input
          placeholder="Recherche nom, prénom"
          v-model="filters.keyword"
          class="pf-table-view__filter-item pf-table-view__keyword-input"
          @keyup.enter.native="getUsers"
        ></el-input>
        <el-select
          class="pf-table-view__filter-item"
          v-model="filters.role"
          placeholder="role"
        >
          <el-option label="--Rôle--" :value="null"></el-option>
          <el-option
            v-for="role in roles"
            :key="`role__${role.value}`"
            :label="role.label"
            :value="role.value"
          ></el-option>
        </el-select>

        <el-select
          class="pf-table-view__filter-item"
          v-model="filters.categorie"
          placeholder="Classification"
        >
          <el-option label="--Categorie--" :value="null"></el-option>
          <el-option
            v-for="categorie in categories"
            :key="`categorie__${categorie.value}`"
            :label="categorie.label"
            :value="categorie.value"
          ></el-option>
        </el-select>

        <base-button
          @click.native="getUsers"
          class="pf-table-view__filter-item pf-table-view__search-button"
          :fluid="false"
          >Recherche</base-button
        >
        <base-button
          class="pf-table-view__filter-item--add"
          @click.native="handleUserAddClick"
          type="hollowed"
          :fluid="false"
          >Ajouter</base-button
        >
      </base-container>
      <base-container :fluid="true" class="pf-table-view__table">
        <el-table
          ref="table"
          :data="structuredUsers"
          :default-sort="{ prop: 'created_at', order: 'descending' }"
          :row-class-name="typeBackground"
          style="width: 100%"
          border
          fit
          highlight-current-row
          empty-text="Aucun utilisateur trouvé"
          @sort-change="sortUsers($event)"
        >
          <el-table-column
            align="center"
            prop="id"
            label="id"
            width="70"
            sortable
          ></el-table-column>
          <el-table-column
            align="center"
            prop="last_name"
            label="Nom"
            min-width="80"
            sortable
          ></el-table-column>

          <el-table-column
            align="center"
            prop="first_name"
            label="Prénom"
            min-width="80"
            sortable
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="company"
            label="Société"
            min-width="100"
            sortable
          ></el-table-column>
          <el-table-column
            align="center"
            prop="role_string"
            label="Rôle"
            min-width="70"
            sortable
          ></el-table-column>
          <el-table-column
            align="center"
            prop="email"
            label="Email"
            min-width="140"
            sortable
          ></el-table-column>
          <el-table-column
            align="center"
            label="Actions"
            min-width="100"
            class-name
          >
            <template slot-scope="{ row }">
              <el-button
                @click="handleTableItemEdit(row)"
                class="action-buttton action-buttton--edit"
                type="primary"
                icon="el-icon-edit"
                circle
              ></el-button>
              <el-button
                @click="handleTableItemDelete(row)"
                class="action-buttton action-buttton--delete"
                type="danger"
                icon="el-icon-delete"
                circle
              ></el-button>
              <el-button
                @click="handleTableItemShow(row)"
                class="action-buttton action-buttton--show"
                type="info"
                icon="el-icon-view"
                circle
              ></el-button>
              <el-button
                @click.native="handleTableItemConnect(row)"
                class="action-buttton action-buttton--show"
                type="success"
                icon="el-icon-user"
                circle
                v-if="row.admin_access"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </base-container>
      <base-container
        :fluid="true"
        :centered="true"
        class="pf-table-view__pagination"
      >
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalUsers"
          :current-page.sync="filters.page"
          :page-size="usersPerPage"
          @current-change="getUsers"
        ></el-pagination>
      </base-container>
    </div>
  </base-container>
</template>

<script>
import {
  Pagination,
  Button,
  Input,
  Table,
  TableColumn,
  Select,
  Option
} from "element-ui"
import TheHeader from "@/components/TheHeader"
import { fetchUsers } from "@/api/users"
import { emitter } from "@/utils"
import { loaderMixin } from "@/mixins"
import { mapState } from "vuex"

export default {
  components: {
    TheHeader,
    ElInput: Input,
    ElButton: Button,
    ElPagination: Pagination,
    ElTable: Table,
    ElTableColumn: TableColumn,
    ElSelect: Select,
    ElOption: Option
  },
  mixins: [loaderMixin],
  data() {
    return {
      users: [],
      filters: {
        keyword: "",
        page: 1,
        role: null
      },
      roles: [
        { label: "Admin", value: "admin" },
        { label: "Freelance", value: "freelancer" },
        { label: "Pharmacien", value: "pharmacist" },
        { label: "Annonceur", value: "annonceur" }
      ],
      categories: [
        { label: "Standard", value: "1" },
        { label: "Blue", value: "2" },
        { label: "Gold", value: "3" },
        { label: "Platinium", value: "4" }
      ],
      usersPerPage: 0,
      totalUsers: 0,
      sortParams: {
        sortField: null,
        sortDirection: null
      }
    }
  },
  computed: {
    structuredUsers() {
      return this.users
        .slice()
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    },
    sortedUsers() {
      return this.users.slice().sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === "desc") modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
    ...mapState(["user"])
  },
  methods: {
    typeBackground({ row }) {
      if (row.type === "standard") {
        return "row--standard"
      } else if (row.type === "Grand compte") {
        return "row--grand"
      }
      return ""
    },
    getUsers() {
      this.openLoader(this.loadingTarget)
      const filters = { ...this.filters, ...this.sortParams }
      fetchUsers(filters)
        .then(res => {
          this.users = res.data.map(u => {
            u.role_string = this.roles.find(r => r.value === u.role).label
            return u
          })
          // console.log(this.users)

          this.currentPage = res.current_page
          this.usersPerPage = res.per_page
          this.totalUsers = res.total

          this.closeLoader()
        })
        .catch(() => {
          this.closeLoader()
        })
    },
    handleTableItemEdit(item) {
      this.$store.dispatch("openModal", {
        name: "edit-user-form--admin",
        payload: { user: item, users: this.users }
      })
    },
    handleTableItemDelete(item) {
      this.$store.dispatch("openModal", {
        name: "confirm-user-delete--admin",
        payload: { user: item, users: this.users }
      })
    },
    handleTableItemShow(item) {
      this.$store.dispatch("openModal", {
        name: "show-user--admin",
        payload: { user: item }
      })
    },
    handleUserAddClick() {
      this.$store.dispatch("openModal", {
        name: "add-user-form--admin",
        payload: {
          users: this.users
        }
      })
    },
    handleTableItemConnect(item) {
      //console.log("We can log in as the pharmacist")
      this.$store
        .dispatch("loginAs", {
          name: "login-as",
          payload: {
            user: item
          }
        })
        .then(() => {
          // Redirect to the pharmacist's home page
          window.location.href = `${window.location.origin}/`
        })
    },
    async logout() {
      await this.$store.dispatch("logOut")
      this.$router.push("/login")
    },
    sortUsers(params) {
      if (params.prop && params.order) {
        const sortOrder = params.order[0] === "d" ? "desc" : "asc"
        this.sortParams.sortField =
          params.prop === "role_string" ? "role" : params.prop
        this.sortParams.sortDirection = sortOrder
      }
      this.getUsers()
    }
  },
  mounted() {
    this.loadingTarget = this.$refs.table.$el.querySelector(
      ".el-table__body-wrapper"
    )
    this.getUsers()

    emitter.$on("update-table", () => {
      this.getUsers()
    })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" src="@/styles/table.scss"></style>

<style lang="scss">
.el-table .row--grand {
  background: rgba(160, 220, 255, 0.788);
}
</style>
